import { Get, Post } from './index'

// OpenAI 提问
export const completions = Post('/chatApi/chat')
// 查询余量
export const announcement = Get('/chatApi/announcement')
